import { getCleanUrlPath } from '../helpers';

/**
 * extracts service name from the backend api endpoint
 */
export function getUrlAndServiceName(
	baseUrl: string,
	servicePath: string,
): {
	fullUrl: string;
	serviceName: string;
} {
	const serviceEndpoint = servicePath.replace(baseUrl, '');
	return {
		fullUrl: getCleanUrlPath(baseUrl) + serviceEndpoint,
		serviceName: serviceEndpoint.split('/')?.[1] ?? '',
	};
}
